export default __webpack_public_path__ + "static/media/logo-cinco-grey.c89b0194.svg";